/**
 * Env var helpers - narrow Vite env vars from string|false to string|undefined
 * @module shared/envHelpers
 */

/**
 * Safely read a Vite environment variable, returning undefined for false/missing
 */
export function getEnvString(value: string | false | undefined): string | undefined {
  return typeof value === 'string' ? value : undefined;
}
